import { CircularProgress as MuiCircularProgress } from "@mui/material";

const CircularProgress = ({ containerStyle = {} }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: "300px",
        ...containerStyle,
      }}
    >
      <MuiCircularProgress size={30} color="#6b8e76" />
    </div>
  );
};

export default CircularProgress;
